// this is a quick workaround to extract basic methods of service models into a single place
// could be done simpler if a model instance was always present, even for inactive service
class ServiceState {
    // this will allow to simplify it by accepting plain Model classes - now factory methods are provided instead,
    // because BillingModel should be fetched using specific project id, while other service models don't use ids yet
    // TODO: make all services use a specific project id explicitly to unify this logic
    constructor({ createSingleModelInstance, fetchSingleModelInstance }) {
        this._createModelInstance = createSingleModelInstance;
        this._fetchModelInstance = fetchSingleModelInstance;
        this._modelInstance = null;
    }

    getModelInstance() {
        return this._modelInstance;
    }

    activate() {
        const modelInstance = this._createModelInstance();

        return modelInstance
            .save()
            .then((savedModelInstance) => {
                this._modelInstance = savedModelInstance;
            })
            .catch((reason) => {
                const HTTP_CONFLICT = 409;

                if (reason && reason.status === HTTP_CONFLICT) {
                    // conflict indicates service's state being updated from another source, so just reload it
                    return this.load();
                }
                throw reason;
            });
    }

    set(attrs) {
        const modelInstance =
            this.getModelInstance() || this._createModelInstance();

        this._modelInstance = modelInstance;

        modelInstance.set(attrs);
    }

    serviceIsActive() {
        const model = this.getModelInstance();
        return model && model.get('status') !== 'UNACTIVATED';
    }

    load() {
        const shouldCreateNewModelInstance = !this._modelInstance;

        const fetchPromise = shouldCreateNewModelInstance
            ? this._fetchModelInstance()
            : this._modelInstance.expire().fetch();

        return fetchPromise
            .catch((reason) => {
                // right now each service info endpoint returns a specific error code as a sign of the service being inactive,
                // and these error codes are service-specific,
                // so we have to treat them as special cases

                // here we expect reason to be a 'request' instance
                if (reason) {
                    const request = reason;

                    const isInactiveServiceError =
                        request.status === INACTIVE_SERVICE_ERROR_CODE ||
                        // TODO: remove this after fixing storage to use unified error code for inactive service, as other services
                        request.status === 400;

                    // FIXME: check body for specific error message after fixing backend - now GPU and containers return empty body
                    // as error codes can be also used for more traditional purpose of indicating actual client errors,
                    // we have to check for a specific response additionally

                    if (isInactiveServiceError) {
                        // if a service is not active, we don't set any model instance on purpose - right now this is a sign of inactive service
                        return null;
                    }
                }

                // default to normal error behaviour
                throw reason;
            })
            .then((modelInstance) => {
                if (modelInstance) {
                    this._modelInstance = modelInstance;
                }
                return {
                    newModelInstanceCreated:
                        shouldCreateNewModelInstance && modelInstance,
                };
            });
    }

    // TODO: remove this - outer code shouldn't care about cache state
    resetCache() {
        this.load._invalidateCache();
    }
}

export { ServiceState };

const INACTIVE_SERVICE_ERROR_CODE = 404;
